// Initial State for Chat
export const Initial_State = {
    rooms: [],
    activeRoom: null,
    messages: {},
    typingUsers: {},
    unreadCounts: {},
    loading: false,
    error: null
};

export default Initial_State;
